/** Display strings and tel: URIs — booking & orders by phone only */

export const PHONE_BOOKING_DISPLAY = "+7 (925) 347-14-20";
export const PHONE_BOOKING_TEL = "tel:+79253471420";

export const PHONE_MAIN_DISPLAY = "+7 (495) 395-77-76";
export const PHONE_MAIN_TEL = "tel:+74953957776";

export const ADDRESS_LINE = "ул. Мусы Джалиля, 4, корп. 6, Москва";
export const METRO_LINES = ["м. Шипиловская", "м. Красногвардейская", "м. Борисово"];

export const MAP_LINK =
  "https://yandex.ru/maps/-/CDHDfRj0";

export const MAP_EMBED_SRC =
  "https://yandex.ru/map-widget/v1/org/liga/157168697301/?ll=37.740686%2C55.628698&utm_source=share&z=16";

export const TELEGRAM_CHANNEL_URL = "https://t.me/billiardliga";
